export type WidgetSize = "small" | "medium" | "large";
export type WidgetCategory = "kpi" | "chart" | "top";

export interface WidgetDef {
  id: string;
  name: string;
  category: WidgetCategory;
  defaultW: number; // grid columns
  defaultH: number; // grid rows
  minW?: number;
  minH?: number;
}

export const WIDGET_REGISTRY: WidgetDef[] = [
  // KPI cards
  { id: "metric-posts", name: "Počet příspěvků", category: "kpi", defaultW: 1, defaultH: 1 },
  { id: "metric-reach", name: "Celkový dosah", category: "kpi", defaultW: 1, defaultH: 1 },
  { id: "metric-engagement", name: "Engagement", category: "kpi", defaultW: 1, defaultH: 1 },
  { id: "metric-engrate", name: "Engagement rate", category: "kpi", defaultW: 1, defaultH: 1 },
  { id: "metric-avg-reach", name: "Ø dosah / post", category: "kpi", defaultW: 1, defaultH: 1 },
  { id: "metric-avg-eng", name: "Ø eng. / post", category: "kpi", defaultW: 1, defaultH: 1 },
  { id: "metric-sessions", name: "Sessions (GA4)", category: "kpi", defaultW: 1, defaultH: 1 },
  { id: "metric-conversions", name: "Konverze (GA4)", category: "kpi", defaultW: 1, defaultH: 1 },

  // Charts
  { id: "chart-engagement", name: "Engagement trend (FB vs IG)", category: "chart", defaultW: 2, defaultH: 3, minW: 2, minH: 2 },
  { id: "chart-sessions", name: "Sessions trend (GA4)", category: "chart", defaultW: 2, defaultH: 3, minW: 2, minH: 2 },
  { id: "chart-reach", name: "Dosah trend", category: "chart", defaultW: 2, defaultH: 3, minW: 2, minH: 2 },
  { id: "chart-traffic", name: "Zdroje návštěvnosti", category: "chart", defaultW: 2, defaultH: 3, minW: 1, minH: 2 },
  { id: "chart-devices", name: "Zařízení", category: "chart", defaultW: 2, defaultH: 3, minW: 1, minH: 2 },
  { id: "chart-post-types", name: "Typy příspěvků", category: "chart", defaultW: 2, defaultH: 3, minW: 1, minH: 2 },

  // Top posts
  { id: "top-fb", name: "Top FB příspěvky", category: "top", defaultW: 2, defaultH: 4, minW: 2, minH: 2 },
  { id: "top-ig", name: "Top IG příspěvky", category: "top", defaultW: 2, defaultH: 4, minW: 2, minH: 2 },
];

export const CATEGORY_LABELS: Record<WidgetCategory, string> = {
  kpi: "KPI metriky",
  chart: "Grafy",
  top: "Top příspěvky",
};

export const DEFAULT_WIDGETS = [
  "metric-posts", "metric-reach", "metric-engagement", "metric-engrate",
  "chart-engagement", "chart-sessions",
  "chart-traffic", "chart-post-types",
  "top-fb", "top-ig",
];
